export function cleanURL(url) {
  if (url == null) {
    return url;
  }

  return url.replace(/\/\//gm, '/');
}